'use strict';

export const GpsStatus = {
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  REQUESTING: 'REQUESTING',
  SUCCESS: 'SUCCESS', // read once
  WATCHING: 'WATCHING', // reading periodically
  WATCHING_ERROR: 'WATCHING_ERROR', // reading periodically, last effort failed
  ERROR: 'ERROR', // failed to retrieve gps location
  STOPPED: 'STOPPED', // Stopped watching gps data
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/enums/GpsStatus.js